import React from 'react';
import styled from 'styled-components';
import { constants } from '../../constants/index';
import { AutoCompleteSC } from './AutoCompleteSC';




/*

Props:


*/

const StyledDiv = styled.div`
    display: flex;
    align-items: center;
    position: inherit;
    background-color: #ffffffe0 !important;
    padding-left: 15px;
    max-width: 500px;
    width: ${props => props.width}px;
    left: 50%;
    /*
    margin-left: -${props => props.width/2}px;
   */ 
    background-origin: border-box !important;
    box-shadow: -7px 11px 78px -24px rgba(0,0,0,0.16);
    `;


const SearchBarSC = ({ styles, children, hintText, dataSource, onUpdateInput, filter, width, ...rest }) => (
    <StyledDiv style = {styles} width={width} {...rest} >
        { children }
        <AutoCompleteSC
            hintText={hintText}
            dataSource={dataSource}
            onUpdateInput={onUpdateInput}
            filter={filter}
            width={width}
        />
    </StyledDiv>
)



export default SearchBarSC




// WEBPACK FOOTER //
// ./src/js/components/Search/SearchBarSC.jsx